import axios from 'axios';
import { from } from 'rxjs';

export const getParsedAddressPromise = (address) => {
  return axios
    .post('/address/parse', {
      address,
    })
    .then((response) => {
      return response?.data;
    });
};

export const getParsedAddress = (address) => {
  const request = getParsedAddressPromise(address);
  return from(request);
};

export const validateAddressPromise = (address) => {
  let arrayAddress = address;
  if (!Array.isArray(arrayAddress)) {
    arrayAddress = [address];
  }
  const addingOtherThings = arrayAddress.map((addy) => {
    const countryCode = addy.countryCode && addy.countryCode.trim() !== '' ? addy.countryCode : 'US';
    return {
      ...addy,
      countryCode,
      validationResult: 'Unverified',
      validationMessage: '',
      orderToken: '',
      bypassSanitization: false,
      bypassSanitizationIntl: false,
    };
  });
  return axios.post('/address/validate', addingOtherThings).then((response) => {
    return response.data;
  });
};

export const validateAddress = (address) => {
  const addressValidation$ = from(validateAddressPromise(address));
  return addressValidation$;
};

export const unlockAddress = (fulfillmentPlanIds) => {
  const post = axios.post('/fulfillmentplan/unlockaddress', {
    fulfillmentPlanIds,
  });

  const post$ = from(post);
  return post$;
};
